import React, { useState, useEffect } from 'react';
import './TelegramPopup.scss';

const TELEGRAM_POPUP_CLOSED_TIMESTAMP_KEY = 'reddicks_telegram_popup_closed_at'; // Renamed key for clarity
const TELEGRAM_GROUP_URL = 'https://t.me/RedDicks_XRD';
const FOUR_DAYS_IN_MS = 4 * 24 * 60 * 60 * 1000;

const TelegramPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [hasJoined, setHasJoined] = useState(false);

  useEffect(() => {
    const closedTimestampStr = localStorage.getItem(TELEGRAM_POPUP_CLOSED_TIMESTAMP_KEY);
    let shouldShow = true;

    if (closedTimestampStr) {
      const closedTimestamp = parseInt(closedTimestampStr, 10);
      if (!isNaN(closedTimestamp)) {
        const now = Date.now();
        if (now - closedTimestamp < FOUR_DAYS_IN_MS) {
          shouldShow = false; // Don't show if closed within the last 4 days
        }
      }
    }

    // Reset state if component re-mounts
    setHasJoined(false);

    if (shouldShow) {
      // Delay the popup appearance slightly
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500); // 1.5 second delay

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsDismissed(true);
    // Add a slight delay for the hide animation before setting local storage
    setTimeout(() => {
      const now = Date.now();
      localStorage.setItem(TELEGRAM_POPUP_CLOSED_TIMESTAMP_KEY, now.toString());
    }, 500); // Match transition duration
  };

  const handleJoin = () => {
    setHasJoined(true);
  };

  // Determine the class based on visibility and dismissal state
  const popupClass = `telegram-popup ${isVisible && !isDismissed ? 'show' : isDismissed ? 'hide' : ''}`;

  // Don't render anything if it's not visible or dismissed after animation
  if (!isVisible || (isDismissed && !popupClass.includes('show'))) {
    // Added check to prevent hiding during the initial fade-in
    if (!isVisible && !isDismissed) return null; // Ensure it doesn't render if never meant to show
    if (isDismissed) { // Only return null if dismissal animation should have ended
        // Check if animation likely finished (adjust time if needed)
        // This logic is simplified, relies on CSS transition time
        // A more robust approach might use onTransitionEnd
        // but this keeps it simpler for now.
        // We return null immediately if dismissed was set
        // because the CSS handles the fade out.
         // The check for !isVisible should prevent initial null render
         if (isDismissed && !popupClass.includes('show')) return null;
    }
    if (!isVisible) return null;

  }


  return (
    <div className={popupClass}>
      <button className="close-button" onClick={handleClose} aria-label="Close Telegram Invite">
        &times;
      </button>

      {!hasJoined ? (
        <>
          {/* Optional: Add an icon here */}
          {/* <div className="popup-icon"></div> */}
          <h4>Join the Reddicks Community!</h4>
          <p>
            Be the first to know about exclusive <strong>giveaways</strong> and{' '}
            <strong>game tournaments</strong>! Connect with the team and other players.
          </p>
          <a
            href={TELEGRAM_GROUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="join-button"
            onClick={handleJoin}
          >
            Join Telegram Group
          </a>
        </>
      ) : (
        <>
          {/* Optional: Add a success icon or similar */}
          <h4>Thanks for joining!</h4>
          <p>
            Say hi in the channel and let us know you are coming from the Reddicks website!
          </p>
          {/* You could add another button here if needed, e.g., "Close" */}
        </>
      )}
    </div>
  );
};

export default TelegramPopup; 